import { useRef, useEffect, useState } from 'react';
import { Marker, MarkerProps } from 'react-leaflet';

interface MarkerAutoPopupProps extends MarkerProps {  
}

function MarkerAutoPopup(props:MarkerAutoPopupProps) { 
    const markerRef = useRef<L.Marker>(null);

    useEffect(() => {
        if (markerRef.current) {
            try {
                markerRef.current.openPopup();
            } catch(err) {
                console.log('err : ' + err);
            }
        }
    }, []);

    return (
        <Marker ref={markerRef} {...props}> 
            {props.children}
        </Marker>
      );
}

export default MarkerAutoPopup;
